export default{
    getSet(state) {
        return state;
    },  
    getMtm(state)
    {
        return state.mtm_join
    }  
}